import React, { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { getApplicationSettings } from 'src/modules/applications/slices';
import ApplicationErrorBoundary from './ApplicationErrorBoundary';

const BrandedApplicationErrorBoundary = ({ children }: PropsWithChildren) => {
  const settings = useSelector(getApplicationSettings);

  return (
    <ApplicationErrorBoundary settings={settings} context="root-providers">
      {children}
    </ApplicationErrorBoundary>
  );
};

export default BrandedApplicationErrorBoundary;
